import {
  LocalizationApi,
  ControlcenterMelcoModelsLocaleStringListItem,
  useAPIQuery,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTable } from "../table/useTable";

import { useTableErrorComponent } from "../table/useTableErrorComponent";
import { LocaleStringsListFiltersType } from "./LocaleStringsListFilterType";
import { PRODUCT_CODE } from "../../helper/localestringHelper";

//const DEFAULT_SESSION_STATUS_FILTER = ALL_ORDER_SESSION_STATUS;

export const useLocaleStrings = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    currentPage,
    pageSize,
    sortBy,
  } = useTable<
    ControlcenterMelcoModelsLocaleStringListItem,
    LocaleStringsListFiltersType
  >({
    pageSizeOptions: [10, 20],
    pageSize: 20,
  });

  const query = useAPIQuery(
    LocalizationApi,
    ["localeString", currentPage, pageSize, filters, sortBy()],
    async (api) => {
      //const api = new ControlCenterApi(baseApiConfig({ token }));
      console.log({ filters, currentPage, pageSize });
      let response;
      //      if(filters?.CultureCode) {
      console.log(filters?.cultureCode);
      response = await api.localizationGetList({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        moduleCode: PRODUCT_CODE,
        cultureCode:
          filters?.cultureCode && !isEmpty(filters.cultureCode)
            ? filters.cultureCode
            : "",
        searchText:
          filters?.searchText && !isEmpty(filters.searchText)
            ? filters.searchText
            : "",
      });
      //  }

      setTotal(response?.total ? response?.total : 0);

      return response?.list ? response?.list : [];
      //   return null
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    errorComponent,
    ...query,
  };
};
